module.exports = __webpack_public_path__ + "img/2022_jeep-wrangler.52c62610.png";